export function registerAssetFallback() {
    if (!window.isSecureContext || !('serviceWorker' in navigator)) return Promise.resolve();
    return new Promise(resolve => {
        const serviceWorker = navigator.serviceWorker;
        let timer;
        const finish = () => {
            clearTimeout(timer);
            serviceWorker.removeEventListener('controllerchange', onControllerChange);
            resolve();
        };
        const onControllerChange = () => { if (serviceWorker.controller) finish(); };
        serviceWorker.addEventListener('controllerchange', onControllerChange);
        // Registration failure must never prevent the application from opening.
        timer = setTimeout(finish, 2000);
        serviceWorker.register('/asset-fallback-sw.js', { scope: '/', updateViaCache: 'none' })
            .then(() => { if (serviceWorker.controller) finish(); })
            .catch(finish);
    });
}
